// extracted by mini-css-extract-plugin
export default {"badge":"courseTable_badge__e7nIN","tableActions":"courseTable_tableActions__oM3Bo"};